import type {AxiosPromise} from 'axios'
import axios, {CancelToken} from '@/plugin/axios'
import api from '@/api'
const cancelFn: Record<string, (reason?: string) => void> = {}

export const product = {
  fetchDetails,
  fetchMaintenanceSchedule,
  fetchAvailableRegions,
  fetchSoftware
}

function fetchDetails(serialNumber: string, business_unit: string): AxiosPromise {
  return axios.get(
    api.getEndpoint(api.endpoints.DPMM_API.PRODUCTS_DETAILS, {
      serial: serialNumber.toUpperCase()
    }),
    {params: {business_unit: (business_unit || '').toUpperCase()}}
  )
}

function promiseWrapper<T = any>(_promise: Promise<any>): Promise<T> {
  return new Promise((resolve, reject) => {
    _promise.then(({data}) => {
      resolve(data)
    }).catch(e => {
      if (e.code === 404 && e.message.startsWith('Standard service intervals')) resolve([] as any)
      else reject(e)
    })
  })
}

function fetchMaintenanceSchedule(_sn: string, business_unit: string): Promise<any> {
  if (typeof cancelFn['maintenance'] === 'function') cancelFn['maintenance']('isCancelled')
  return promiseWrapper(axios.get(api.endpoints.DPMM_API.SERVICE_MAINTENANCE_DETAILS.replace('{serial}', _sn), {
    cancelToken: new CancelToken(function executor(c) { cancelFn['maintenance'] = c }),
    params: {
      business_unit: business_unit.toUpperCase()
    }
  }))
}

function fetchAvailableRegions(): AxiosPromise {
  return axios.get(api.endpoints.DPMM_API.AVAILABLE_REGIONS)
}

function fetchSoftware(_sn: string): AxiosPromise {
  if (typeof cancelFn['software'] === 'function') cancelFn['software']('isCancelled')
  return axios.get(api.endpoints.DPMM_API.MACHINE_SOFTWARE.replace('{serial}', _sn), {
    cancelToken: new CancelToken(function executor(c) { cancelFn['software'] = c })
  })
}
